module.exports = __webpack_public_path__ + "img/galeria-acuariofilia-1.909085a7.jpg";